import Papa from "papaparse";

import {
  detectFileTextEncoding,
  IGenericUploadParseResult,
  IGenericUploadRowInfo,
  TGenericUploadParsedCsvRow,
} from "@ryde/shared";

export const genericUploadCsvFile = async ({
  file,
}: {
  file: File;
}): Promise<IGenericUploadParseResult> => {
  // papaparse defaults to UTF-8, which mangles the windows-1255 CSVs Excel produces in Hebrew.
  const encoding = await detectFileTextEncoding(file);

  return new Promise((resolve, reject) => {
    const onComplete = (
      result: Papa.ParseResult<TGenericUploadParsedCsvRow>,
    ): void => {
      const data = result.data;
      const transformedData: IGenericUploadRowInfo[] = data.map(
        (item, index) => {
          const parsedExtra = item.__parsed_extra;

          delete item.__parsed_extra;

          const transformedItem: IGenericUploadRowInfo = {
            index: index + 1,
            row: { ...item },
          };

          if (parsedExtra?.length) {
            transformedItem.extraFields = parsedExtra;
          }

          return transformedItem;
        },
      );

      resolve({ data: transformedData });
    };

    Papa.parse<TGenericUploadParsedCsvRow>(file, {
      worker: true,
      header: true,
      skipEmptyLines: true,
      encoding,
      error: err => reject(err),
      complete: onComplete,
    });
  });
};
